import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { CAPS, monthLabel } from "../lib/csvAnalysis";

const MonthSelect = ({ value, onChange, months, testId }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="h-9 w-[110px] bg-[#0B0F19] border-slate-700 text-slate-100 font-mono text-xs"><SelectValue /></SelectTrigger>
    <SelectContent className="max-h-72">
      {months.map((m) => <SelectItem key={m} value={m} className="font-mono text-xs">{monthLabel(m)}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const RangeBar = ({ months, from, to, setRange, capIdx, setCapIdx, hasHop }) => {
  const n = months.length;
  const presets = [["all", "All", 0], ["l3", "Last 3", 3], ["l6", "Last 6", 6], ["l12", "Last 12", 12]].filter(([, , k]) => k < n);
  const isPreset = (k) => to === months[n - 1] && from === months[k ? n - k : 0];
  const set = (a, b) => setRange(a <= b ? [a, b] : [b, a]);
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3 panel px-4 py-3" data-testid="range-bar">
      <div className="flex items-center gap-2">
        <span className="label-mono">From</span>
        <MonthSelect value={from} onChange={(v) => set(v, to)} months={months} testId="range-from-select" />
        <span className="label-mono">To</span>
        <MonthSelect value={to} onChange={(v) => set(from, v)} months={months} testId="range-to-select" />
      </div>
      <div className="flex flex-wrap gap-1">
        {presets.map(([id, l, k]) => (
          <button key={id} data-testid={`range-preset-${id}`} onClick={() => setRange([months[k ? n - k : 0], months[n - 1]])}
            className={`text-xs px-3 py-1.5 rounded-md border transition-colors ${isPreset(k) ? "border-ep/60 bg-ep/10 text-ep-soft" : "border-slate-700 text-slate-400 hover:bg-slate-800"}`}>{l}</button>
        ))}
      </div>
      {hasHop && (
        <div className="flex items-center gap-2 lg:ml-auto">
          <span className="label-mono" title="Hops longer than this are treated as breaks and excluded from picks per hour">Break cutoff</span>
          <Select value={String(capIdx)} onValueChange={(v) => setCapIdx(+v)}>
            <SelectTrigger data-testid="break-cutoff-select" className="h-9 w-[100px] bg-[#0B0F19] border-slate-700 text-slate-100 font-mono text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>{CAPS.map((c, i) => <SelectItem key={c} value={String(i)} className="font-mono text-xs">{c / 60} min</SelectItem>)}</SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
};
